import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import EmployeeCard from '@/platform/common/components/EmployeeCard/EmployeeCard';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import PlaceholderValue from '@/platform/common/components/PlaceholderValue/PlaceholderValue';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import { localDate } from '@/platform/lib/utils';
import {
    Button,
    Container,
    FilterBarDropdown,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';

const DgvIndexView = () => {
    const { auth, dgv_entitlements: dgvEntitlements } = usePage().props;
    const { filters, updateFilters } = useFilters(['dgv_entitlements']);

    const showEntity = filters?.entity_ids?.length > 1;
    const numberOfColumns = showEntity ? 6 : 5;

    const canDownloadScreenshot = auth?.permissions?.includes(
        'download dgr screenshot'
    );

    return (
        <Container fluid>
            <Segment>
                <SegmentHeader
                    header={`Binnengekomen doelgroepverklaringen (${dgvEntitlements?.meta?.total || 0})`}
                />
                <SegmentContent>
                    <SearchBarFilter only={['dgv_entitlements']}>
                        <FilterBarDropdown
                            multiple
                            selectAll
                            label={`Entiteiten (${filters?.entity_ids?.length || 0}/${auth?.customer?.entities?.length || 0})`}
                            options={auth?.customer?.entities?.map(entity => ({
                                id: entity.id,
                                name: entity.name,
                            }))}
                            value={filters?.entity_ids || []}
                            onChange={value =>
                                updateFilters('entity_ids', value)
                            }
                        />
                    </SearchBarFilter>

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                {showEntity && (
                                    <TableHeaderCell>Entiteit</TableHeaderCell>
                                )}
                                <TableHeaderCell>Werknemer</TableHeaderCell>
                                <TableHeaderCell>
                                    Datum indienst
                                </TableHeaderCell>
                                <TableHeaderCell>
                                    Datum uitdienst
                                </TableHeaderCell>
                                <TableHeaderCell className='w-px'>
                                    Doelgroepverklaring
                                </TableHeaderCell>
                                <TableHeaderCell className='w-px'>
                                    DGR Screenshot
                                </TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {dgvEntitlements?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={numberOfColumns} />
                            )}

                            {dgvEntitlements?.data?.map(entitlement => (
                                <TableRow key={entitlement.id}>
                                    {showEntity && (
                                        <TableCell>
                                            {
                                                entitlement?.employee?.entity
                                                    ?.name
                                            }
                                        </TableCell>
                                    )}
                                    <TableCell>
                                        <EmployeeCard
                                            employee={entitlement?.employee}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <PlaceholderValue placeholder='n.v.t'>
                                            {localDate(
                                                entitlement.employment_start_date
                                            )}
                                        </PlaceholderValue>
                                    </TableCell>
                                    <TableCell>
                                        <PlaceholderValue placeholder='n.v.t'>
                                            {localDate(
                                                entitlement.employment_end_date
                                            )}
                                        </PlaceholderValue>
                                    </TableCell>
                                    <TableCell className='w-px' singleLine>
                                        {entitlement?.dgv_document_id && (
                                            <Button
                                                as='a'
                                                href={`/documents/${entitlement.dgv_document_id}`}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                            >
                                                <ArrowDownTrayIcon
                                                    aria-hidden='true'
                                                    className='size-4'
                                                />
                                                {localDate(
                                                    entitlement?.dgv_document
                                                        ?.created_at
                                                )}
                                            </Button>
                                        )}
                                    </TableCell>
                                    <TableCell className='w-px' singleLine>
                                        {entitlement?.dgr_identity_check
                                            ?.document_id &&
                                            canDownloadScreenshot && (
                                                <Button
                                                    as='a'
                                                    href={`/dgr-identity-check/${entitlement.dgr_identity_check.id}/screenshot/download`}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                >
                                                    <ArrowDownTrayIcon
                                                        aria-hidden='true'
                                                        className='size-4'
                                                    />
                                                    {localDate(
                                                        entitlement
                                                            ?.dgr_identity_check
                                                            ?.document
                                                            ?.created_at
                                                    )}
                                                </Button>
                                            )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination
                        meta={dgvEntitlements?.meta}
                        only={['dgv_entitlements']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default DgvIndexView;
